import { Component, OnInit, Input } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';

@Component({
    selector: 'marv-section-title',
    templateUrl: './section-title.component.html',
    styleUrls: ['./section-title.component.scss'],
    imports: [IonIcon]
})
export class MarvSectionTitleComponent  implements OnInit {

    @Input({alias : 'label', required : true}) titleSection: string;
    @Input({alias : 'icon', required : false}) iconSection: string;

    constructor() { }

    ngOnInit() {}

}
